<template>
  <div class="py-4 container-fluid">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-lg-12 position-relative z-index-2">
        <div class="row">
          <div class="col-sm-7">
            <h1 class="mainTitle">Dashboard</h1>
            <span class="mainDescription">Hello, Admin</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Stats Cards -->
    <div class="row">
      <div class="col-xl-3 col-sm-6 mb-4" v-for="card in stats" :key="card.title">
        <div class="card shadow border-0" :style="{ backgroundColor: '#f4b8a6', color: '#fff' }">
          <div class="card-body text-center py-4">
            <div class="mb-2">
              <i class="material-icons-round" style="font-size: 2rem; color: white">{{ card.icon }}</i>
            </div>
            <h6 class="text-white text-sm mb-1">{{ card.title }}</h6>
            <h4 class="mb-0">{{ card.value }}</h4>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Links -->
    <div class="row mt-4">
      <div class="col-md-12">
        <h5 class="mb-3">Quick Actions</h5>
        <div class="d-flex gap-3 flex-wrap">
          <router-link to="/products/create" class="btn text-white" style="background-color: #f4b8a6">
            <i class="material-icons-round me-1">add</i> New Product
          </router-link>
          <router-link to="/reviews" class="btn text-white" style="background-color: #f4b8a6">
            <i class="material-icons-round me-1">rate_review</i> Manage Reviews
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "@/Axios";
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

export default {
  name: "dashboard-default",
  data() {
    return {
      stats: [
        { title: "Contacts", value: 0, icon: "contacts", key: "contacts" },
        { title: "Reviews", value: 0, icon: "rate_review", key: "reviews" },
        { title: "Products", value: 0, icon: "inventory_2", key: "products" },
      ],
      overview: {
        total_revenue: 0,
        total_orders: 0,
        pending_orders: 0,
        monthly_revenue: {},
      },
      report: {
        subtotal_revenue: 0,
        shipping_total: 0,
        total_revenue: 0,
        total_orders: 0,
        delivered_orders: 0,
        canceled_orders: 0,
      },
    };
  },

  async created() {
    try {
      // Get overview stats
      const statsRes = await axios.get("/dashboard/stats");
      const statsData = statsRes.data.data;

      this.stats = this.stats.map((stat) => ({
        ...stat,
        value: statsData[stat.key] || 0,
      }));

      this.overview.total_revenue = statsData.total_revenue || 0;
      this.overview.total_orders = statsData.total_orders || 0;
      this.overview.pending_orders = statsData.pending_orders || 0;
      this.overview.monthly_revenue = statsData.monthly_revenue || {};

      // Get order report
      const reportRes = await axios.get("/dashboard/order-report");
      this.report = reportRes.data.data;

      this.$nextTick(() => this.renderChart());
    } catch (error) {
      console.error("Failed to load dashboard data:", error);
    }
  },

  methods: {
    renderChart() {
      const canvas = document.getElementById("revenueChart");
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      const labels = Object.keys(this.overview.monthly_revenue);
      const values = Object.values(this.overview.monthly_revenue);

      new Chart(ctx, {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Revenue (KWD)",
              data: values,
              backgroundColor: "#f4b8a6",
              borderRadius: 6,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: { display: false },
          },
        },
      });
    },
  },
};
</script>
